import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import MainProducts from "../components/products/MainProducts";

const PriceListScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <MainProducts />
      </main>
    </>
  );
};

export default PriceListScreen;
